import { ChangeEvent, useEffect, useState } from "react"
import { AddressForm } from "src/components/common/form/address/AddressForm"
import { DropDownForm } from "src/components/common/form/DropdownForm"
import { ImageForm } from "src/components/common/form/ImageForm"
import { InputForm } from "src/components/common/form/input/InputForm"
import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto"
import { SysCodeDto } from "src/dtos/code/sysCodeDto"
import { defaultMST4010_R01Dto, MST4010_R01Dto } from "./Dto_MST4010_R01"
import { useCommonCodeStore } from "src/store/useCommonCodeStore"
import { useMST4010_R01Store } from "./Store_MST4010_R01"
import useUiuxStore from "src/store/useUiuxStore"
import { formatDate, formatPhoneNumber, formatRegNo } from "src/utils/string/stringUtil"
import { handleKeyDown, syntheticEvent } from "src/utils/commonForm/commonFormUtils";

import { BRDiv } from "src/components/common/common"
import useScreenStore from "src/store/useScreenStore"
import { InfoCodeSearchFieldConfig } from "src/types/info-form"
import { getEmployeeList } from "src/apis/employeeApi"
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents"
import { CodeForm } from "src/components/common/form/CodeForm"
import { SingleDateForm } from "src/components/common/form/SingleDateForm"

// Props 타입 정의: data는 선택된 회사 정보(선택적)
interface Props {
	data?: MST4010_R01Dto
	defaultMST4010_R01Row: MST4010_R01Dto;
}

// 회사 정보 입력/수정 컴포넌트
export const Info_MST4010_R01 = ({ data, defaultMST4010_R01Row }: Props) => {

	// zustand 스토어에서 상태 및 setter 가져오기
	const { selectedMST4010_R01, editMST4010_R01, setEditMST4010_R01 } = useMST4010_R01Store();
	const { setCodeSearchModalProps, } = useUiuxStore();
	const { cycleList, eqmTypeList, eqmStatusList, yesNoList,
		compCdList, orgCdList, workPlaceList
	} = useCommonCodeStore();

	const [manufactureDtPickerVisible, setManufactureDtPickerVisible] = useState(false);
	const [manufactureDtPickerPos, setManufactureDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});
	const [purchaseDtPickerVisible, setPurchaseDtPickerVisible] = useState(false);
	const [purchaseDtPickerPos, setPurchaseDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});
	const [disposalDtPickerVisible, setDisposalDtPickerVisible] = useState(false);
	const [disposalDtPickerPos, setDisposalDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const eqmPersonHandleFoucsId = 'eqmPersonInput';

	// input/select 값 변경 핸들러
	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		setEditMST4010_R01({
			...editMST4010_R01,
			[name]:  value
		});
	}

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'eqmPerson',
			category: '담당자',
			focusId: eqmPersonHandleFoucsId,
			responseMapping: {
				empNo : 'eqmPerson',
				empNm : 'eqmPersonNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				eqmPerson: editMST4010_R01?.eqmPerson || '',
				eqmPersonNm: editMST4010_R01?.eqmPersonNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editMST4010_R01,
		setEditData: setEditMST4010_R01,
		defaultData: defaultMST4010_R01Row,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST4010_R01'
	});

	const inputWrapperStyle = {
		wrapperStyle: "w-[250px] min-w-[250px] mr-[10px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		inputStyle: "w-[150px] min-w-[150px]",
	}

	const codeWrapperStyle = {
		wrapperStyle: "w-[250px] min-w-[250px] mr-[10px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		codeInputStyle: "w-[80px] min-w-[80px]",
		custNmInputStyle: "w-[65px] min-w-[65px]",
	}
	const eqmImageWrapperStyle = {
		wrapperStyle: "w-[300px] min-w-[300px] h-[250px]",
	}

	// 렌더링
	return(
		<div
			className="w-full h-full overflow-auto grid items-start border border-gray-300"
			style={{ gridTemplateColumns: "clamp(544px, calc(100% - 300px), 804px) minmax(300px, 1fr)" }}
		>
			<div className={`
				h-full flex flex-wrap content-start p-[12px]`}>

				{/* editMST4010_R01 : 	{JSON.stringify(editMST4010_R01)} */}

				<InputForm title="설비코드" 	value={editMST4010_R01.equipmentCd}		editable={selectedMST4010_R01 === undefined}	name="equipmentCd"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="설비명" 		value={editMST4010_R01.equipmentNm}		editable={true}									name="equipmentNm"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="설비규격" 	value={editMST4010_R01.equipmentSpec}	editable={true}									name="equipmentSpec"	onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<DropDownForm 
					title="설비유형"
					value={editMST4010_R01.equipmentType}
					data={eqmTypeList}
					editable={true}
					name="equipmentType"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>
				<DropDownForm 
					title="공정"
					value={editMST4010_R01.workplaceCd}
					data={workPlaceList}
					editable={true}
					name="workplaceCd"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>	
				<InputForm title="설비순서" 	value={editMST4010_R01.equipmentSeq}	editable={true}									name="equipmentSeq"		onChange={handleChange} wrapperOption={inputWrapperStyle} />

				<DropDownForm 
					title="사업장"
					value={editMST4010_R01.compCd}
					data={compCdList}
					editable={true}
					name="compCd"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>
				<DropDownForm 
					title="관리부서"
					value={editMST4010_R01.eqmOrgcd}
					data={orgCdList}
					editable={true}
					name="eqmOrgcd"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>

				<CodeForm
					label="담당자"
					value={editMST4010_R01?.eqmPerson || ""}
					custNmValue={editMST4010_R01?.eqmPersonNm || ""}
					editable={true}
					handleFoucsId={eqmPersonHandleFoucsId}
					name="eqmPerson"
					wrapperOption={codeWrapperStyle}
					handleChange={getFieldHandlers('eqmPerson').onChange}
					onDoubleClick={getFieldHandlers('eqmPerson').onDoubleClick}
					onKeyDown={getFieldHandlers('eqmPerson').onEnterKeyDown}
				/>

				<InputForm title="제조사" 	value={editMST4010_R01.manufacturerNm}	editable={true}									name="manufacturerNm"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				
				<SingleDateForm
					title="제조일자"
					value={editMST4010_R01?.manufactureDt ? new Date(editMST4010_R01.manufactureDt) : new Date()}
					setValue={(value: Date | undefined) => setEditMST4010_R01({...defaultMST4010_R01Row, ...editMST4010_R01, manufactureDt: value ? formatDate(value) : undefined})}
					editable={true}
					visible={manufactureDtPickerVisible}				setVisible={setManufactureDtPickerVisible}
					onChange={handleChange}
					pickerPos={manufactureDtPickerPos}						setPickerPos={setManufactureDtPickerPos}
					wrapperOption={inputWrapperStyle}
				/>
				<InputForm title="일련번호" 	value={editMST4010_R01.eqmSerial}	editable={true}									name="eqmSerial"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="매입처" 	value={editMST4010_R01.purchaseNm}	editable={true}									name="purchaseNm"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<SingleDateForm
					title="매입일자"
					value={editMST4010_R01?.purchaseDt ? new Date(editMST4010_R01.purchaseDt) : new Date()}
					setValue={(value: Date | undefined) => setEditMST4010_R01({...defaultMST4010_R01Row, ...editMST4010_R01, purchaseDt: value ? formatDate(value) : undefined})}
					editable={true}
					visible={purchaseDtPickerVisible}				setVisible={setPurchaseDtPickerVisible}
					onChange={handleChange}
					pickerPos={purchaseDtPickerPos}						setPickerPos={setPurchaseDtPickerPos}
					wrapperOption={inputWrapperStyle}
				/>
				<InputForm title="매입금액" 	value={editMST4010_R01.purchaseAmt}	editable={true}									name="purchaseAmt"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				
				<InputForm title="전력(KW)" 	value={editMST4010_R01.eqmPower}		editable={true}									name="eqmPower"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="사용전류(V)" 	value={editMST4010_R01.eqmVolt}			editable={true}									name="eqmVolt"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="기타규격" 	value={editMST4010_R01.otherSpec}		editable={true}									name="otherSpec"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="SIZE(W)" 		value={editMST4010_R01.sizeWidth}		editable={true}									name="sizeWidth"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="SIZE(H)" 		value={editMST4010_R01.sizeHeight}		editable={true}									name="sizeHeight"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<InputForm title="SIZE(D)" 		value={editMST4010_R01.sizeDepth}		editable={true}									name="sizeDepth"		onChange={handleChange} wrapperOption={inputWrapperStyle} />

				<InputForm title="중량" 	value={editMST4010_R01.sizeWeight}		editable={true}									name="sizeWeight"		onChange={handleChange} wrapperOption={inputWrapperStyle} />
				<SingleDateForm
					title="폐기일자"
					value={editMST4010_R01?.disposalDt ? new Date(editMST4010_R01.disposalDt) : new Date()}
					setValue={(value: Date | undefined) => setEditMST4010_R01({...defaultMST4010_R01Row, ...editMST4010_R01, disposalDt: value ? formatDate(value) : undefined})}
					editable={true}
					visible={disposalDtPickerVisible}				setVisible={setDisposalDtPickerVisible}
					onChange={handleChange}
					pickerPos={disposalDtPickerPos}						setPickerPos={setDisposalDtPickerPos}
					wrapperOption={inputWrapperStyle}
				/>
				<DropDownForm 
					title="상태"
					value={editMST4010_R01.eqmStatus}
					data={eqmStatusList}
					editable={true}
					name="eqmStatus"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>

				<InputForm title="접속IP" value={editMST4010_R01.linkIp} editable={true} wrapperOption={inputWrapperStyle} name="linkIp" onChange={handleChange} />
				<InputForm title="접속PORT" value={editMST4010_R01.linkPort} editable={true} wrapperOption={inputWrapperStyle} name="linkPort" onChange={handleChange} />
				<DropDownForm 
					title="데이타수집"
					value={editMST4010_R01.gatheringCycle.toString()}
					data={cycleList}
					editable={true}
					name="gatheringCycle"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>

				<DropDownForm 
					title="작업지시"
					value={editMST4010_R01.instrucTag}
					data={yesNoList}
					editable={true}
					name="instrucTag"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>
				<DropDownForm 
					title="가상설비"
					value={editMST4010_R01.virtualEqm}
					data={yesNoList}
					editable={true}
					name="virtualEqm"
					initLabelLess = {true}
					onChange={handleChange}
					wrapperOption={inputWrapperStyle}
				/>
				<InputForm title="화면조회순서" value={editMST4010_R01.displaySeq} editable={true} wrapperOption={inputWrapperStyle} name="displaySeq" onChange={handleChange} />

					<BRDiv />

				<InputForm title="비고" value={editMST4010_R01.remark} editable={true} wrapperOption={{
					wrapperStyle: "w-[670px] min-w-[670px] mr-[10px] mb-[10px]",
					titleStyle: "w-[100px] min-w-[100px]",
					inputStyle: "w-full min-w-full"
				}} name="remark" onChange={handleChange} />
			</div>
			<div className="min-w-0 h-full flex flex-wrap content-start gap-[12px] pt-[12px] pr-[12px]">
				<ImageForm title="설비사진" image={editMST4010_R01.eqmImage} onImageChange={(eqmImage) => setEditMST4010_R01({ ...editMST4010_R01, eqmImage })} wrapperOption={eqmImageWrapperStyle} previewEnabled />
				<ImageForm title="설비사진2" image={editMST4010_R01.eqmImage2} onImageChange={(eqmImage2) => setEditMST4010_R01({ ...editMST4010_R01, eqmImage2 })} wrapperOption={eqmImageWrapperStyle} previewEnabled />
			</div>
		</div>
	)
}
